import Vue from 'vue'
import App from "./App"
import router from '@/router'
import store from '@/store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/font/iconfont.css'
import '@/common/font/SourceHanSansCN.css'
import "./permission"
import './registerServiceWorker'
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
import 'videojs-contrib-hls'
import clipboard from 'clipboard'
import moment from "moment"
import * as tools from '@/common/tools'
Object.keys(tools).forEach(key => {
    Vue.filter(key, tools[key]);
})
Vue.use(VideoPlayer)
Vue.use(ElementUI)
Vue.prototype.$moment = moment
Vue.prototype.clipboard = clipboard
Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
